<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite">新增</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="openPage" :disabled="!canWrite">选择</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="!canWrite">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="onIssue">下发任务</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="handleDelete" :disabled="!isSave || !canWrite">删除</el-button>
        <!-- <el-button type="primary" style="margin-left: 4px" :disabled="!isSave" @click="onPrint(row)">打印</el-button> -->
        <el-button type="primary" @click="openSetField">明细字段</el-button>
      </div>
      <el-form :model="data" ref="form" :inline="true" :line-form="true" label-width="80px" status-icon>
        <el-row style="margin-top: 18px">
          <el-form-item label="单据日期:" required label-width="120px">
            <!-- <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span> -->
            <el-date-picker v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px" @change="v => getPreviewNo(v)"> </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码:" required label-width="120px">
            <!-- <span style="display: inline-block; width: 180px" v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span> -->
            <el-input style="width: 180px" v-model="data.DocNo" placeholder="请输入单据编码"></el-input>
          </el-form-item>
          <el-form-item label="领料类型:" required label-width="110px">
            <el-select v-model="data.InType" @change="handleInTypeChange">
              <el-option :value="1" label="按产品领料"></el-option>
              <el-option :value="2" label="按工单领料"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型:" required label-width="110px">
            <el-select v-model="data.ProductionType" @change="handleProductionTypeChange">
              <el-option :value="0" label="自制"></el-option>
              <el-option :value="1" label="委外"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="领出仓库:" required label-width="100px">
            <el-select style="width: 180px" v-model="data.GeneralWarehouseId" @change="changeDataGeneralWarehouse">
              <el-option v-for="item in warehouseList1" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="领入仓库:" required label-width="100px">
            <el-select style="width: 180px" v-model="data.SiteWarehouseId">
              <el-option v-for="item in warehouseList2" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商:" prop="TradeUnitId" label-width="90px">
            <el-select v-model="data.TradeUnitId" filterable placeholder="请选择供应商单位">
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" @click.native="TradeUnitChange(item)" :value="item.TradeUnitId" :label="item.FullName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车间" label-width="100px">
            <v-select style="width: 180px" ref="typeSelect" v-model="data.DpId" clearable />
          </el-form-item>
          <el-form-item label="制单人:" label-width="120px">
            <span class="span" style="width: 180px !important">{{ data.MakeEmpName }}</span>
          </el-form-item>
          <!-- 经手人 -->
          <el-form-item label="经手人:" prop="EmpId" label-width="90px">
            <select-input placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 190px" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:" label-width="120px">
              <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" style="width: 600px" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        key="table1"
        border
        class="table_bottom table-line tb-c-head"
        :row-class-name="tableRowClassName"
        :data="tableData.filter(item => item.T != 2)"
        stripe
        style="margin-top: 18px"
        v-if="showDetail"
        ref="table1"
        @row-click="addColumn"
      >
        <!-- <el-table-column width="50" prop="Sn" align="left" label="序号" v-if="showField('序号')" /> -->
        <insert-row @on-insert="onInsert" />
        <el-table-column min-width="140" prop="ProductName" label="存货名称" v-if="showField('存货名称')">
          <template slot-scope="{ row }">
            <account-select
              v-model="row.ProductName"
              :source="DAccount"
              @select="onSelect($event, row)"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal"
              @inputText="inputText"
              @click.native="resetFun"
              @currentPage="currentPage"
              :pageType="true"
            />
          </template>
        </el-table-column>
        <el-table-column min-width="100" prop="ProductNo" label="存货编码" v-if="showField('存货编码')" />
        <el-table-column min-width="120" prop="ProductSpec" label="规格型号" v-if="showField('规格型号')" />
        <el-table-column width="60" prop="Quantity" align="left" label="批号" v-if="showField('批号')" />
        <el-table-column prop="GeneralWarehouseId" label="领出仓库" min-width="120" v-if="showField('领出仓库')" >
          <template slot-scope="{ row }">
            <el-select v-model="row.GeneralWarehouseId" @change="editT(row)">
              <el-option v-for="item in warehouseList1" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="GeneralWarehouseId" label="领入仓库" min-width="120" v-if="showField('领入仓库')" >
          <template slot-scope="{ row }">
            <el-select v-model="row.SiteWarehouseId" @change="editT(row)">
              <el-option v-for="item in warehouseList2" :key="item.key" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="计量单位" min-width="60px" v-if="showField('计量单位')">
          <template slot-scope="{ row, $index }">
            <el-select v-if="row.Units && row.Units.length > 0" v-model="row.UnitId">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
            </el-select>
            <span v-else>{{ row.UnitName }}</span>
          </template>
        </el-table-column>
        <el-table-column width="100" prop="Quantity" label="数量" v-if="showField('数量')">
          <template slot-scope="{ row, $index }">
            <el-input type="text" v-model="row.Quantity" @change="changeQuantity($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column width="100" prop="Rate" align="right" label="换算率" v-if="showField('换算率')" />
        <el-table-column align="center" label="计量单位2" min-width="80px" v-if="showField('计量单位2')">
          <template slot-scope="{ row, $index }">
            <span>{{ row.UnitName2 }}</span>
            <!-- <el-select v-if="row.Units && row.Units.length > 0" v-model="row.UnitId2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
            </el-select>
            <span v-else-if="row.UnitType == 0"></span>
            <span v-else>{{ row.UnitName2 }}</span> -->
          </template>
        </el-table-column>
        <el-table-column width="100" prop="Quantity2" align="right" label="数量2" v-if="showField('数量2')" />
        <el-table-column width="100" prop="PickingQuantity" align="right" label="累计领料数" v-if="showField('累计领料数')" />
        <el-table-column min-width="160" label="备注" v-if="showField('备注')">
          <template slot-scope="{ row }">
            <el-input v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
          </template>
        </el-table-column>

        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="{ row, $index }">
            <el-button type="text" size="mini" @click="onRowDelete(row, $index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <edit-dialog ref="editDialog" @saved="saved" :ProcessStage="data.ProcessStage" :ProductionType="data.ProductionType" :InType="data.InType"></edit-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import editDialog from './editDialog'
import accountSelect from '@/components/business/stock/select'
import mouldSelect from '@/components/production/clothmanagement/cloth/select'

import empDialog from '@/components/personnel/result/record/listDialog'
import optionMixins from '@/mixins/option'
import fieldDialog from '@/components/common/fieldDialog'
import vSelect from '@/components/business/stock/productionpicking/vSelect'

export default {
  name: 'editmaterials',
  mixins: [optionMixins],
  components: {
    editDialog,
    accountSelect,
    mouldSelect,
    empDialog,
    fieldDialog,
    vSelect
  },
  data() {
    return {
      api: require('@/api/pr/prGetDocTask').default,
      pdApi: require('@/api/ba/product').default,
      code_api: require('@/api/sy/serialCode').default,
      commonApi: require('@/api/common/common').default,
      docSetting_api: require('@/api/sy/docSetting').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      Mode: 0,
      viewType: 'create',
      Status: 1,
      data: {
        DocId: 0,
        DocDate: this.$commonJs.getToday(),
        ClerkId: null, //经办人
        ClerkName: null,
        InType: 1,
        GetType: 0, //入库类型
        SiteWarehouseId: null,
        ProcessStage: '', //加工阶段
        ProductionType: 0, //生产类型
        Quantity: 0, //生产人数
        WorkShopId: 0, //车间
        TradeUnitId: '', //加工商
        EmpName: '', //制单人员
        EmpId: 0 //制单人员
      },
      isSave: false,
      tableData: [],
      detailFields: [],
      showDetail: false,
      warehouseList1: [], // 库存仓
      warehouseList2: [], // 现场仓/车间仓
      oneselfList:[],    //自制仓库下拉数据
      outsourceList:[], //委外仓库下拉数据
      tradeUnitList: [],
      DAccount: [],
      initDAccount: [],
      listTotal: 0,
      initTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      }
    }
  },
  created() {
    this.init()
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/productionshipping')
    },
    canWrite() {
      return this.$permission.canWrite('/business/stock/productionshipping')
    },
    canReview() {
      return this.$permission.canReview('/business/stock/productionshipping')
    },
    ReviewStatus() {
      return this.Status == 2 ? true : false
    }
  },
  mounted() {
    this.viewType = this.$route.params.type
    if (this.$route.params.type === 'create') {
      this.getPreviewNo()
      const user = this.$store.state.user
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
        this.data.MakeEmpName = user.name
        this.data.MakeEmpId = user.empId
      }
      this.data.ReviewTime = this.$commonJs.getToday()
    } else if (this.$route.params.type === 'edit') {
      this.editInit(this.$route.params.data)
    }
  },
  methods: {
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({
          DocType: '领料通知单',
          Url: 'production/ticketmanagement/dispatch/edit'
        })
      })
    },
    setTbField() {
      this.showDetail = false
      this.docSetting_api.list({ DocType: '领料通知单', IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey)
          this.$nextTick(() => {
            this.showDetail = true
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1
    },
    setEmp(data) {
      console.log(data)
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    getPreviewNo(dateTime = '') {
      this.code_api.previewNo('领料通知单', dateTime).then(res => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.$set(this.data, 'DocNo', res.Data.PreviewNo)
        } else {
          this.$message.warning('获取领料通知单编号失败')
        }
      })
    },
    editInit(data) {
      console.log('🚀 ~ editInit ~ data:', data)
      this.data = { ...data }
      this.viewType = 'edit'
      this.isSave = true
      this.Status = data.Status

      this.tableData = data.Products.map(x => {
        return {
          ...x,
          T: null
        }
      })
    },
    init() {
      this.warehouseApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.warehouseList1 = res.Data
        }
      })

      // 自制仓库下拉数据
      this.warehouseApi.list({ Status: 1, WarehouseType: 2 }).then(res => {
        if (res.Code === 0) {
          this.warehouseList2 = res.Data.map(item => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId
            }
          })
          this.oneselfList = res.Data.map(item => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId
            }
          })
        }
      })
      // 委外仓库下拉数据
      this.warehouseApi.list({ Status: 1, WarehouseType: 3 }).then(res => {
        if (res.Code === 0) {
          this.outsourceList = res.Data.map(item => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId
            }
          })
        }
      })

      this.tradeUnitApi.list({ TradeUnitTypes: [1, 2, 3], Status: 1 }).then(res => {
        if (res.Code == 0) this.tradeUnitList = res.Data
      })

      this.sourceTypeApi.info('领料通知单').then(res => {
        this.data.GetType = res.SourceTypeId
      })

      this.pdApi.list({ pageIndex: 1, pageSize: 7, Status: 1 }).then(res => {
        this.DAccount = res.Data
        this.initDAccount = res.Data
        this.listTotal = res.Count
        this.initTotal = res.Count
      })

      this.addList()
      this.callOptionApi()
      this.setTbField()
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(5))
    },
    editT(row) {
      if (row.T == null) {
        row.T = 1
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    TradeUnitChange(val) {
      this.data.TradeUnitName = val.FullName
    },
    async openPage() {
      if (this.data.ProductionType == 1 && !this.data.TradeUnitId) {
        return this.$message.warning('请先选择供应商')
      }
      if (!this.data.InType) {
        this.$message.warning('请先选领料类型')
        return
      }

      let that = await this.$refs.editDialog.open()
      let OrderType = 0
      if (this.data.ProductionType == 0) {
        const res = await this.sourceTypeApi.info('生产领料单') // 自制
        OrderType = res.SourceTypeId
      } else {
        const res = await this.sourceTypeApi.info('委外领料单') //委外
        OrderType = res.SourceTypeId
      }

      that.get_data({
        OrderType,
        ProductionType: this.data.ProductionType,
        TradeUnitId: this.data.TradeUnitId,
        InType: this.data.InType,
        DpId: this.data.DpId,
        TradeUnitId: this.data.TradeUnitId
      })
    },
    interpolate(row, index, type = '') {
      let o = {
        T: 0,
        OrderProductId: 0,
        // OrderId: 0,
        ColorId: null,
        ColorName: '',
        BarCode: '',
        ExistQuantity: 0,
        ProductId: 0,
        Offer: 0,
        Discount: 0,
        NoTaxPrice: 0,
        TaxRate: 0,
        Price: 0,
        BatchNo: '',
        NoTaxAmount: 0,
        TaxAmount: 0,
        Amount: 0,
        PackQuantity: 0,
        PickingQuantity: 0,
        UnitId2: 0,
        Quantity2: 0,
        LineAbortEmpId: 0,
        LineAbortDate: '',
        LineAbort: 0,
        IsGift: false,
        LineAbortEmpName: '',
        UnitName: '',
        Unit2Name: '',
        SourceType: 0,
        SourceOrderId: 0,
        SourceDtsId: 0,

        SourceTypeName: '',
        PuUnitId: 0,
        PurchaseQuantity: 0,
        DeliveryDate: '',
        Rate: 0,
        DiscountAmount: 0,
        ProductNo: '',
        ProductSpec: '',
        ProductName: '',
        ExecutionQuantity: 0,
        ExecutionQuantity2: 0,
        PriceType: null,
        SourceType: 0,
        SourceDocNo: '',
        StockQuantity: 0,
        ExistQuantity: 0
      }
      if (type == 'down') {
        index = index + 1
      }
      this.tableData.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.tableData))
      this.tableData = []
      this.$nextTick(() => {
        this.tableData = copy
      })
    },
    onInsert(e) {
      let { type, index } = e

      this.interpolate(null, index, type)
    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    changeDataGeneralWarehouse(){
      this.tableData.forEach(item => {
        if(item.T != 0){
          this.$set(item, 'T', 1)
        }
        this.$set(item, 'GeneralWarehouseId', this.data.GeneralWarehouseId)
      })
    },
    async saved({ subList }) {
      let arr = []
      const res = await this.sourceTypeApi.info('领料通知单')
      console.log('res', res)
      let SourceType = res.SourceTypeId
      subList.forEach(item => {
        let o = {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          WorkDocNo: '',
          SiteWarehouseId: null,
          GeneralWarehouseId: null,
          SiteWarehouseName: '',
          GeneralWarehouseName: '',
          ProductId: item.ProductId,
          ProductNo: item.ProductNo,
          ProductName: item.ProductName,
          ProductSpec: item.ProductSpec,
          PropertyId: item.PropertyId || 0,
          PropertyName: item.PropertyName || '',
          UseColor: item.UseColor,
          UseProcess: item.UseProcess,
          ColorId: item.ColorId || 0,
          ColorName: item.ColorName || '',
          Colors: item.Colors || [],
          Units: item.Units || [],
          UnitId: item.UnitId,
          UnitName: item.UnitName,
          Quantity: item.Quantity,
          Price: 0,
          Price2: 0,
          Amount: 0,
          SourceDocId: item.WorkDocId,
          SourceNo: item.WorkDocNo,
          SourceDtsId: item.WorkDocMaterialId,
          SourceType: SourceType,
          SiteWarehouseId: this.data.SiteWarehouseId,
          SiteWarehouseName: this.data.SiteWarehouseName,
          GeneralWarehouseId: item.DefaultWarehouse,
          GeneralWarehouseName: '',
          Grammage: item.Grammage,
          HasGrammage: item.HasGrammage,
          Variable: item.Variable,
          SkUnitId: item.SkUnitId,
          SkUnitName: item.SkUnitName
        }
        arr.push(o)
        if (this.tableData.length == 0 || !this.tableData[0].SourceNo) {
          this.data.GeneralWarehouseId = arr[0].GeneralWarehouseId
          this.data.GeneralWarehouseName = arr[0].GeneralWarehouseName
        }
      })

      arr.forEach((item, i) => {
        item.isSource = item.SourceDocId === 0 || item.SourceDocId == null ? false : true
        item.UnitType = 0
        item.ChangeType = 0
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length === 0) {
        } else {
          item.UnitType = 1

          let index = this.getUnitIndex(3, item.Units, item.UnitId)
          let data = this.getUnitValue(item.Units, index)
          let assistIndex = 0
          let assistData = {}
          item.IsMain = data.IsMain
          // row.ChangeType1 = data.ChangeType;
          item.Units.forEach(item2 => {
            if (item2.ChangeType == 1) item.ChangeType = item2.ChangeType
          })
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, item.Units)
            assistData = this.getUnitValue(item.Units, assistIndex)
            item.Rate = assistData.Rate.toFixed(5)
          } else {
            assistIndex = this.getUnitIndex(1, item.Units)
            assistData = this.getUnitValue(item.Units, assistIndex)
            item.Rate = data.Rate.toFixed(5)
          }
          item.UnitId2 = assistData.UnitId
          item.UnitName2 = assistData.UnitName
          // row.ChangeType2 = assistData.ChangeType;
        }

        this.changeQuantity(arr[i].Quantity, item, i, 1)
      })

      this.tableData.unshift(...arr)
    },
    // 新增单据
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: 'warning', message: '请先进行保存再操作' })
        return
      } else {
        Object.assign(this.$data, this.$options.data.call(this))
        this.getPreviewNo()
        this.$route.params.type = 'create'
        this.viewType = 'create'
        this.init()
        this.isSave = false
      }
    },
    // 复制
    onCopy() {
      if (!this.isSave) {
        this.$message({ type: 'warning', message: '请先进行保存再操作' })
        return
      } else {
        // Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo()
        this.$route.params.type = 'create'
        this.viewType = 'create'
        // this.init();
        this.isSave = false
        this.data.DocId = 0
        this.Status = 1
        this.data.DocDate = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
        this.tableData = this.tableData.map(item => {
          return {
            ...item,
            T: 0,
            DocProductId: 0
          }
        })
      }
    },
    // 父表-删除
    handleDelete() {
      let id = this.data.DocId
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.api.delete({ id }).then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.newAdd()
            // this.$emit('deleted')
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
    // 任务下发
    onIssue() {
      const o = { ids: [this.data.DocId], Status: 1 }
      this.api.updateStatus(o).then(res => {
        if (res.Code == 0) {
          this.$message.success(res.Msg)
          this.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    onPrint(row) {
      var url = location.origin + '/#/customprintview/领料通知单/' + this.data.DocId
      window.open(url, '_blank')
    },
    //切换生产类型
    handleProductionTypeChange(newValue) {
      if (newValue === 0) {
        this.data.TradeUnitId = null
        this.data.TradeUnitName = null
      }
        this.$confirm('切换生产类型将清空表格数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$set(this.data, 'SiteWarehouseId', null)
            this.warehouseList2 = newValue == 0 ? this.oneselfList : this.outsourceList
            for (let i = this.tableData.length - 1; i >= 0; i--) {
              const row = this.tableData[i]
              if (row.T === null || row.T === 1) {
                row.T = 2
              } else if (row.T === 0) {
                this.tableData.splice(i, 1)
              }
            }
            this.addList()
          })
          .catch(() => {
            this.$nextTick(() => {
              this.data.ProductionType = newValue === 0 ? 1 : 0
              this.warehouseList2 = newValue == 0 ? this.outsourceList : this.oneselfList
            })
          })
    },
    handleInTypeChange(newValue) {
      if (this.tableData.length > 0) {
        this.$confirm('切换领料类型将清空表格数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            for (let i = this.tableData.length - 1; i >= 0; i--) {
              const row = this.tableData[i]
              if (row.T === null || row.T === 1) {
                row.T = 2
              } else if (row.T === 0) {
                this.tableData.splice(i, 1)
              }
            }
          })
          .catch(() => {
            this.$nextTick(() => {
              this.data.InType = newValue === 1 ? 2 : 1
            })
          })
      }
    },
    // 子表-删除
    onRowDelete(row, index) {
      if (row.T == null || row.T == 1) {
        row.T = 2
      } else if (row.T == 0) {
        this.tableData.splice(index, 1)
      }
    },
    reView1() {
      let id = this.data.DocId
      this.api.examine1(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    /*计量单位相关函数*/
    compareUnitId(data, row, index) {
      if (row.T == null) {
        row.T = 1
      }

      let lastIsMain = row.IsMain
      if (data.IsMain) {
        row.IsMain = false
      } else {
        row.IsMain = true
      }
      let findIndex = 0
      if (row.Unit == row.Unit2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (row.IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, row.Units)
          this.changeLeftUnitId(row, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, row.Units)
          this.changeLeftUnitId(row, findIndex)
        }
      } else {
        if (row.IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, row.Units)
          this.changeLeftUnitId(row, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, row.Units)
          this.changeLeftUnitId(row, findIndex, data.Rate)
          if (!lastIsMain) {
            row.Quantity = row.Quantity2
          }
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate))
        }
      }
      this.changeQuantity2(row.Quantity2, row, index, 1)
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') return
      if (row.T == null) {
        row.T = 1
      }

      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(2)
        } else {
          console.log('数量1=数量2/换算率')
          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(2)
        } else {
          console.log('数量1=数量2*换算率')
          row.Quantity = this.getQuantity(data * row.Rate)
        }
      }
    },
    changeLeftUnitId(row, findIndex, Rate = 0) {
      row.Unit = row.Units[findIndex].UnitId
      row.UnitName = row.Units[findIndex].UnitName
      if (Rate > 0) {
        row.Rate = Rate
      }
    },
    // 数量
    changeQuantity(data, row, index) {
      if (row.T == null) {
        row.T = 1
      }
      if (row.Units.length > 0) {
        if (row.IsMain) {
          row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
        } else {
          row.Quantity2 = this.getQuantity(data * Number(row.Rate))
        }
      }
    },
    compareSaUnit(data, row, index) {
      if (row.T == null) row.T = 1

      let lastIsMain = row.IsMain
      this.tableData[index].IsMain = data.IsMain
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex, data.Rate)
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.Quantity2 = row.Quantity
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(2);
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate))
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].UnitName2 = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType2=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    addColumn(row, column) {
      if (row.index === this.tableData.length - 1 && !this.ReviewStatus) {
        this.addList()
      }
    },
    addList() {
      this.tableData.push({
        T: 0,
        OrderProductId: 0,
        // OrderId: 0,
        ColorId: null,
        ColorName: '',
        BarCode: '',
        ExistQuantity: null,
        ProductId: 0,
        Offer: null,
        Discount: 100,
        NoTaxPrice: null,
        TaxRate: null,
        Price: null,
        BatchNo: '',
        NoTaxAmount: null,
        TaxAmount: null,
        Amount: null,
        PackQuantity: null,
        PickingQuantity: null,
        UnitId2: 0,
        Quantity2: null,
        LineAbortEmpId: 0,
        LineAbortDate: '',
        LineAbort: 0,
        IsGift: false,
        LineAbortEmpName: '',
        UnitName: '',
        Unit2Name: '',
        SourceType: 0,
        SourceOrderId: 0,
        SourceDtsId: 0,

        SourceTypeName: '',
        PuUnitId: 0,
        PurchaseQuantity: null,
        DeliveryDate: '',
        Rate: null,
        DiscountAmount: null,
        ProductNo: '',
        ProductSpec: '',
        ProductName: '',
        ExecutionQuantity: null,
        ExecutionQuantity2: null,
        PriceType: '',
        SourceType: 0,
        SourceDocNo: '',
        StockQuantity: null,
        ExistQuantity: null,
        Remark: ''
      })

      console.log('this.tableData', this.tableData)
    },
    // 选择存货名称
    onSelect(e, row) {
      if (row.T == null) row.T = 1
      console.log('e', e)
      let Product = this.tableData.map(i => i.ProductId)
      if (Product.includes(e.ProductId)) return this.$message.warning('产品已存在')

      // if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1
      row.ProductNo = e.ProductNo
      row.ProductName = e.ProductName
      row.ProductId = e.ProductId
      row.ProductSpec = e.ProductSpec
      row.SaUnitId = e.SaUnitId
      row.SaUnitName = e.SaUnitName
      row.UseColor = e.UseColor
      row.Colors = e.Colors
      row.UnitType = 0
      row.Units = e.Units
      row.UnitId = e.BaseUnitId
      row.ChangeType = 0
      // this.colorList = e.Colors;
      // this.optionList = e.Units;
      console.log('SaQuantity', Number(row.SaQuantity))
      // if (!Number(row.SaQuantity)) row.SaQuantity = 1;
      if (e.Units.length === 0) {
        row.UnitId2 = 0
        row.SaUnitName = e.SaUnitName
        row.UnitName2 = ''
        row.Rate = 0
        row.Quantity2 = 0
      } else {
        row.UnitType = 1
        if (row.BaseUnitId) {
          let index = this.getUnitIndex(3, e.Units, row.BaseUnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain
          e.Units.forEach(item => {
            if (item.ChangeType == 1) row.ChangeType = item.ChangeType
          })

          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = this.getIinvexchrate(assistData.Rate)
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = this.getIinvexchrate(data.Rate)
          }
          // console.log(row.Rate,'row.Rate')
          // console.log(assistData,'assistData')
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length
          let mainData = []
          let noMainData = []
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.SaUnitId = mainData[0].UnitId
          row.SaUnitName = mainData[0].UnitName
          row.UnitId2 = noMainData[0].UnitId
          row.UnitName2 = noMainData[0].UnitName
          row.Rate = this.getIinvexchrate(noMainData[0].Rate)
          row.IsMain = true
        }
        if (row.IsMain) {
          row.Quantity2 = this.getQuantity(row.SaQuantity / Number(row.Rate))
        } else {
          row.Quantity2 = this.getQuantity(row.SaQuantity * Number(row.Rate))
        }
        row.Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0)
        row.TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
      }
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text) {
      this.pdApi
        .list({
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    save() {
      //验证表单是否填写
      let yanzheng = ['DocDate', 'DocNo', 'SiteWarehouseId']
      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && !this.data[key]) {
          this.$message({ type: 'warning', message: '表单未填写完整' })
          return
        }
      }

      if (this.data.ProductionType == 1 && !this.data.TradeUnitId) {
        this.$message({ type: 'warning', message: '请选择供应商' })
        return
      }
      for (const item of this.tableData.filter(item => item.ProductNo == null)) {
        if (!item.GeneralWarehouseId) {
          this.$message({ type: 'warning', message: '请选择领出仓库' })
          return
        }
      }

      const Products = this.tableData.filter(item => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null
      })
      let o = { ...this.data, Products }

      this.api.save(o).then(res => {
        if (res.Code === 0) {
          this.$message.success(res.Msg)
          this.isSave = true
          this.data.DocId = res.Data
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message.warning(res.Msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;

  .text {
    width: 60px;
  }
}

.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}

.span {
  display: inline-block;
  width: 180px;
}

.w180 {
  width: 180px;
}
</style>
